export default {
  // 'this' - $store
  byActionType: {

  },
  // 'this' - $store
  byEventType: {
    'MATCH_FORMAT' ({ extra }) {
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        inverse,
        timer_speed_up: timerSpeedUp
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp
      })
    },
    'CANCEL' (event) {
      this.setScore(event)
      this.setCanceled(event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'ADJUST_POINTS' () {
      return this.$t('rocketLeague.adjust.points')
    }
  },
  eventClasses: {

  }
}
